namespace BHW.Admin {
	/**
	 * Initialize the Resync products admin functionality
	 */
	const initResyncIndex = () => {
		document.querySelectorAll('.js-resync-index').forEach(item => {
			item.addEventListener('click', event => {
				if (confirm('Are you sure you want to resync the index now?')) {
					item.classList.add('d-none');
					document.querySelector('.js-loading').classList.remove('d-none');					
				}
				else {
					event.preventDefault();
				}
			});
		});	
	};
	const initBazaarvoiceIndex = () => {
		document.querySelectorAll('.js-bazaarvoice-index').forEach(item => {
			item.addEventListener('click', event => {
					item.classList.add('d-none');
					document.querySelector('.js-loading').classList.remove('d-none');					
				
			});
		});	
	};

	const initClearRedisCache = () => {
		document.querySelectorAll('.js-clear-cache').forEach(item => {
			item.addEventListener('click', event => {
				if (confirm('Are you sure you want to clear the cache?')) {
					(<HTMLInputElement>item).disabled = true;				
				}
				else {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});
		});	
	};

	const initFileSelection = () => {
		const fileSelector: HTMLInputElement = document.querySelector('.js-select-file');
		const btnSubmit: HTMLInputElement = document.querySelector('.js-validate-file');

		function checkFileSelection(fileSelector: HTMLInputElement) {
			if (btnSubmit) {
				if (fileSelector.value) {
					btnSubmit.disabled = false;
					btnSubmit.classList.remove('disabled');
				}
				else {
					btnSubmit.disabled = true;
					btnSubmit.classList.add('disabled');
				}
			}
		}		

		if (fileSelector) {
			checkFileSelection(fileSelector);

			fileSelector.addEventListener('change', event => {				
				checkFileSelection(fileSelector);
			});

			btnSubmit.addEventListener('click', event => {				
				btnSubmit.classList.add('d-none');
				document.querySelector('.js-loading').classList.remove('d-none');
			});	
		}			
	}

	export const init = () => {
		initResyncIndex();
		initBazaarvoiceIndex();
		initClearRedisCache();
		initFileSelection();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	BHW.Admin.init();
});
